<div class="container bg-white pb-3" *ngIf="projectData">

    <ng-hbm-bdi-btn class="primary mt-5 mb-4 text-uppercase" (click)="backToProjects()" [label]="vendorContext ? ('&lt; ' + ('popins.projects.back_customer_projects' | translate) + ' '+customerName) : ('&lt; ' + ('popins.projects.back_projects' | translate))"></ng-hbm-bdi-btn>

    <div class="row">
        <div class="col-7">
            <img [src]="mainImageUrl+'?d='+noCache" class="main-image img-fluid" />
        </div>
        <div class="col-5">
            <span class="icon-bryo-kitchen-compo">
                <svg>
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-bryo-kitchen-compo"></use>
                </svg>
            </span>
            <ng-hbm-bdi-editable-text class="title" (onSubmit)="updateProperty($event,'title')" [value]="projectData.projectName" [placeholder]="'popins.projects.placeholder_name' | translate" [min]="1" [max]="70"></ng-hbm-bdi-editable-text>
            <ng-hbm-bdi-editable-text class="description" (onSubmit)="updateProperty($event,'description')" [value]="projectData.description | nl2br" [placeholder]="'popins.projects.placeholder_desc' | translate" [multiline]="true" [max]="300"></ng-hbm-bdi-editable-text>
            <p><strong>{{ 'popins.projects.last_update' | translate }} :</strong> {{projectData.dateUpdate | date:'d/MM/y - H:mm' }}</p>
            <p><strong>{{ 'popins.projects.creation_date' | translate }} :</strong> {{projectData.dateCreation | date:'d/MM/y - H:mm' }}</p>
            <p class="my-3">
                <ng-hbm-bdi-btn class="primary" (click)="editProject(projectData, $event)" [label]="'popins.projects.edit_project' | translate"></ng-hbm-bdi-btn>

                <span class="bt-text d-inline-block mx-4" (click)="duplicateProject(projectData.projectUUID, projectData.projectID, projectData.projectName, $event)">
                    {{ 'generic.duplicate' | translate }}
                </span>
                <span *ngIf="!projectData.is_locked" class="bt-text d-inline-block" (click)="deleteProject(projectData.projectID, $event)">
                    {{ 'generic.delete' | translate }}
                </span>
                <span *ngIf="vendorContext && !projectData.is_locked" class="bt-text d-inline-block ml-4" (click)="lockProject(projectData.projectID, $event)">
                    {{ 'popins.projects.lock_project' | translate }} 
                </span>
                <span *ngIf="vendorContext && projectData.is_locked" class="bt-text d-inline-block ml-4" (click)="unlockProject(projectData.projectID, $event)">
                    {{ 'popins.projects.unlock_project' | translate }}
                </span>
            </p>
        </div>
    </div>

    <ng-container *ngIf="projectData.medias.renderHQ.length > 0">
        <h2>{{ 'popins.projects.realistic_views' | translate }}</h2>

        <ul class="hq-img-container">
            <li (click)="zoomImage(imgHq.url+'?d='+noCache)" *ngFor="let imgHq of projectData.medias.renderHQ; let i=index" [class.firstOfSixAndMore]="(i===0) && (projectData.medias.renderHQ.length > 6)">
                <img [src]="imgHq.url+'?d='+noCache" class="img-fluid" />
            </li>
        </ul>
    </ng-container>

    <h2>{{ 'popins.projects.plans' | translate }}</h2>
    <div class="plan-img-container">

            <figure class="p-1" *ngFor="let plan2d of projectData.medias.plan2D">
                    <div class="card p-2" (click)="zoomImage(plan2d.url+'?d='+noCache)">
                        <img [src]="plan2d.url+'?d='+noCache" class="img-fluid" />
                        <figcaption class="my-1 text-center">
                            <span class="icon-plan">
                                <svg>
                                    <use xlink:href="assets/img/icons.svg#icon-bryo-plan"></use>
                                </svg>
                            </span>
                            <h3>{{plan2d.name}}</h3>
                        </figcaption>
                    </div>
                </figure>
        </div>

    <h2>{{ 'popins.projects.notes' | translate }}</h2>
    <ng-hbm-bdi-editable-text class="user-notes" (onSubmit)="updateProperty($event,'notes')" [value]="projectData.manualNotes | nl2br" [placeholder]="'popins.projects.add_note' | translate" [multiline]="true" [max]="500000000"></ng-hbm-bdi-editable-text>

</div>